module.exports = __webpack_public_path__ + "8d54adb91d53be8a3c8c84e3e80ca49d.svg";